import axios from 'axios';
import { API_ENDPOINTS } from '../config/api';

interface UserData {
  email: string;
  logintype: 'email' | 'apple';
  nom?: string;
  prenom?: string;
}

class SymfonyApiService {
  /**
   * Créer un membre dans Symfony
   */
  async createMemberToSymfony(userData: UserData, uid: string): Promise<boolean> {
    try {
      const config = {
        headers: {
          'content-type': 'application/json',
        },
      };

      const bodyParameters = {
        email: userData.email,
        password: 'null',
        logintype: userData.logintype,
        firstlaunch: true,
        roles: ['ROLE_USER'],
        firebase: uid,
        plateform: 'web', // Remplace Platform.OS pour le web
      };

      await axios.post(API_ENDPOINTS.USERS, bodyParameters, config);
      console.log('✅ Membre créé dans Symfony:', userData.email);
      return true;
    } catch (error: any) {
      console.error('❌ Erreur création membre Symfony:', error.response?.data || error.message);
      throw new Error('Erreur lors de la création du membre dans Symfony');
    }
  }

  /**
   * Créer les informations utilisateur dans Symfony
   */
  async createUserInformationsToSymfony(
    userData: UserData,
    uid: string,
    today: string
  ): Promise<boolean> {
    try {
      const config = {
        headers: {
          'content-type': 'application/json',
        },
      };

      const bodyParameters = {
        email: userData.email,
        user: `/api/users/${uid}`,
        nom: userData.nom || '',
        prenom: userData.prenom || '',
        createdat: today,
        firstlaunch: true,
        token: `${uid}-${userData.email}-${uid}`,
        firebase: uid,
        plateform: 'web', // Remplace Platform.OS pour le web
      };

      await axios.post(API_ENDPOINTS.USERS_INFORMATIONS, bodyParameters, config);
      console.log('✅ Informations utilisateur créées dans Symfony:', userData.email);
      return true;
    } catch (error: any) {
      console.error('❌ Erreur création informations Symfony:', error.response?.data || error.message);
      throw new Error('Erreur lors de la création des informations utilisateur dans Symfony');
    }
  }

  /**
   * Créer un utilisateur complet (membre + informations)
   */
  async createCompleteUser(userData: UserData, uid: string): Promise<boolean> {
    try {
      const today = new Date().toISOString();

      // Créer le membre
      await this.createMemberToSymfony(userData, uid);

      // Créer les informations utilisateur
      await this.createUserInformationsToSymfony(userData, uid, today);

      console.log('✅ Utilisateur complet créé dans Symfony:', userData.email);
      return true;
    } catch (error: any) {
      console.error('❌ Erreur création utilisateur complet:', error);
      throw error;
    }
  }
}

const symfonyApiService = new SymfonyApiService();
export default symfonyApiService;
